export const MEDIA_TYPE = {
    VIDEO: 'video',
    IMAGE: 'image'
}

export const ACTION_TYPE = {
    PREVIOUS: 'prev',
    NEXT: 'next'
}